<template>
  <div class="card-quick-access">
    <card-quick-links />
    <card-daily-routine />
  </div>
</template>

<script>
import CardDailyRoutine from './CardDailyRoutine.vue';
import CardQuickLinks from './CardQuickLinks.vue';

export default {
  name: 'CardQuickAccess',
  components: {
    'card-quick-links': CardQuickLinks,
    'card-daily-routine': CardDailyRoutine
  }
}
</script>

<style lang="scss" scoped>
.card-quick-access {
  background-color: #FFF;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 2rem;
}
</style>
